function saveConfiguration() {
    return expivi.saveConfiguration(512, 512);
}

async function captureScreenshots(configurationSku) {
    try {
        const angles = [
            "FIT_OBJECT_FRONT",
            "FIT_OBJECT_BACK",
            "FIT_OBJECT_LEFT",
            "FIT_OBJECT_RIGHT"
        ];

        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

        const screenshots = [];
        for (const angle of angles) {
            let base64Image = await window.expivi.getScreenshot(1080, 1080, angle, 'image/png');
            base64Image = base64Image.replace(/^data:image\/png;base64,/, "");
            screenshots.push({ angle, image: base64Image });
            await delay(500);
        }

        const payload = JSON.stringify({
            configurationSku: configurationSku,
            screenshots: screenshots
        });

        const response = await fetch("https://hook.eu2.make.com/inrsuzqe7odj2plcy2iwawgdpypn2km5", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: payload
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        console.log("Screenshots and SKU successfully sent to Make.com");
    } catch (error) {
        console.error("Error capturing or sending screenshots:", error);
        throw error;
    }
}

function createVariant(savedBundle) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: 'POST',
            url: '/apps/configurator',
            data: JSON.stringify({
                configuration: savedBundle.configured_products,
                productId: shopifyProductId
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(function(createResult) {
            createResult.configuredProduct = savedBundle.configured_products[0];

            // TEMPORARY FUNCTION TO DOWNLOAD JSON
            /*(function downloadJson() {
                const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(createResult, null, 2));
                const downloadAnchorNode = document.createElement('a');
                downloadAnchorNode.setAttribute("href", dataStr);
                downloadAnchorNode.setAttribute("download", "createVariant-payload.json");
                document.body.appendChild(downloadAnchorNode);
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
            })();*/

            resolve(createResult);
        }).fail(reject);
    });
}

function addToCart(createResult) {
    return new Promise(function (resolve, reject) {
        let addJsResponse = {
            quantity: 1,
            id: createResult.variant_id,
            properties: createResult.options,
        };

        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify(addJsResponse),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(resolve).fail(reject);
    });
}

window.xpv_hooks_add_to_cart = function(context, event) {
    $button = $(context);
    shopifyProductId = $button.data('productId');

    // Disable button
    if ($button[0].hasAttribute('disabled')) {
        return false;
    }
    event.preventDefault();
    $button.attr('disabled', 'disabled');
    $button.addClass('loading');

    return Promise.resolve()
        .then(function() {
            return saveConfiguration();
        })
        .then(function(result) {
            return createVariant(result);
        })
        .then(function(result) {
            return captureScreenshots(result.options["Configuration SKU"]).then(() => result);
        })
        .then(function(result) {
            return addToCart(result)
        })
        .then(function() {
            if ($button.data('url') !== 'NONE') {
                window.location.href = $button.data('url');
            }

            // Don't let expivi handle add to cart
            return false;
        })
        .catch(function (error) {
            $button.removeAttr('disabled');
            $button.removeClass('loading');
            throw error;
        });
}
